import { AmplificationStatusAPIEnum } from '../../../api/distributions/enum/amplification-status-api.enum';

export enum AmplificationStatusEnum {
    ONLINE_BOOST = 'BOOST',
    NEWSROOM = 'NEWSROOM'
}

export const amplificationStatusFromApi: Map<AmplificationStatusAPIEnum, AmplificationStatusEnum> =
new Map<AmplificationStatusAPIEnum, AmplificationStatusEnum>([
    [AmplificationStatusAPIEnum.ONLINE_BOOST, AmplificationStatusEnum.ONLINE_BOOST],

]);

export const amplificationStatusToApi: Map<AmplificationStatusEnum, AmplificationStatusAPIEnum> = new Map<AmplificationStatusEnum, AmplificationStatusAPIEnum>([
    [AmplificationStatusEnum.ONLINE_BOOST, AmplificationStatusAPIEnum.ONLINE_BOOST],

]);
